import { useNavigate } from '@tanstack/react-router';
import { Clock } from 'lucide-react';

import Button from '@/components/common/Button';
import { useTranslation } from '@/hooks/useTranslation';

const PendingApproval = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="max-w-md mx-auto text-center py-20">
      <div className="mb-8 flex justify-center">
        <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center">
          <Clock className="w-12 h-12 text-amber-500" />
        </div>
      </div>

      <h2 className="text-3xl font-bold text-gray-900 mb-4">
        {t('pendingApproval.title')}
      </h2>

      <p className="text-lg text-gray-600 mb-8">
        {t('pendingApproval.message')}
      </p>

      <div className="space-y-4">
        <Button
          variant="primary"
          size="lg"
          className="w-full cursor-pointer"
          onClick={() => navigate({ to: '/' })}
        >
          {t('returnHome')}
        </Button>

        <button
          onClick={() => navigate({ to: '/login' })}
          className="text-sm text-gray-500 hover:text-gray-700 underline"
        >
          {t('orSignInWithDifferentAccount')}
        </button>
      </div>
    </div>
  );
};

export default PendingApproval;
